import AuthForm from 'components/AuthForm/AuthForm'

const AuthPage: React.FC = (): JSX.Element => {
	return <AuthForm />
}

export default AuthPage
